<template>
  <div>
      <div class="hero">
        <div class="hero-background">
          <img loading=lazy :src='this.heroBackground + "?w=600&auto=compress,format"' />
        </div>

        <HeroLogo class="animation__reveal"
          :projectLogo=this.heroLogo
          :headline=this.heroTitle
          :label=this.heroType
          :layout="layout"
          :size="size"
        ></HeroLogo>

              
        
        <div class="hero-content">
          <div class="details">
            <HeadlineWithLabel class="animation__reveal--1" v-if="this.partners" :headline=this.partners label="Partners"></HeadlineWithLabel>
            <HeadlineWithLabel class="animation__reveal--2" v-if="this.role" :headline=this.role label="Role"></HeadlineWithLabel>
            <HeadlineWithLabel class="animation__reveal--3" v-if=this.project :headline=this.project label="Project"></HeadlineWithLabel>
            <HeadlineWithLabel class="animation__reveal--4" :headline=this.organisation label="Organization"></HeadlineWithLabel>
            <a class="project__link" v-if="link" :href="link" target="_blank">
              <div class="project__button">
                <span>Open Website →</span>
              </div>
          </a>
          </div>
        </div>
        
      </div>
  </div>
</template>

<script>

import HeroLogo from '@/components/HeroLogo.vue';
import HeadlineWithLabel from '@/components/typography/HeadlineWithLabel.vue';

export default {
  name: 'Hero',
  components: {
    HeroLogo,
    HeadlineWithLabel
  },
  props: {
    heroImage: String,
    role: String,
    partners: String,
    project: String,
    organisation: String,
    heroBackground: String,
    heroLogo: String,
    heroTitle: String,
    heroType: String,
    layout: String,
    size: String,
    link: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../assets/scss/colors.scss';
  @import '../assets/scss/mixins.scss';
  @import '../assets/scss/motion.scss';

  .headline-with-labbel {
    opacity: 0;
  }

  .project__link {
    position: relative;
    border-radius: 12px;
    padding: 0 1.5rem;
    background: $dark;
    z-index: 10;
    height: 4rem;
    min-width: 23ch;
    text-decoration: none;
    cursor: pointer;
    display: flex;
    justify-items: center;
    align-items: center;
    align-self: center;
    right: .5rem;
    @include md () {
      position: static;
      margin: 2.5rem 0;
    }
    span {
      font-family: "Inter";
      font-size: 1.25rem;
      color: $light;
    }

    &:hover {
      background: $draft-background;
    }
  }

  .hero {
    position: relative;
    height: 100vh;
    @include sm () {
      height: 150vh;
    }
    .hero-background {
      position: absolute;
      top: 0; left: 0; bottom: 0; right: 0;
      & > img {
        width: 100%;
        object-fit: cover;
        height: 100%;
        position: absolute;
      }
    }

    .hero-logo {
        height: 100%;
        width: 100%;
        z-index: 2;
    }

    .hero-content {
      position: absolute;
      max-width: 100%;
      margin: 0 auto;
      bottom: 0;
      left: 0; 
      right: 0;
      background: $port-background-transparent;
      @include md () {
        padding: 1rem 0;
        max-width: 70ch;
        bottom: 15%;
      }
      @include sm () {
        padding: 1rem 0;
        bottom: 5%;
      }
      .details {
        display: flex;
        bottom: 0;
        align-items: center;
        justify-content: space-evenly;
        padding-bottom: 0.75rem;
        max-width: 1800px;
        margin: 0 auto;
        @include sm () {
          align-items: start;
        }
        @include lg () {
          flex-direction: column;
          padding-bottom: 0;
        }
      }
    }

  }
</style>
